import { render, staticRenderFns } from "./HeaderToolbarUserPopup.vue?vue&type=template&id=328674b2&scoped=true&"
import script from "./HeaderToolbarUserPopup.vue?vue&type=script&lang=js&"
export * from "./HeaderToolbarUserPopup.vue?vue&type=script&lang=js&"
import style0 from "./HeaderToolbarUserPopup.vue?vue&type=style&index=0&id=328674b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328674b2",
  null
  
)

export default component.exports
import {QBtn,QAvatar,QPopupProxy,QCard,QCardSection,QItemSection,QSeparator,QList,QItem,QIcon,QBadge} from 'quasar'
component.options.components = Object.assign({QBtn,QAvatar,QPopupProxy,QCard,QCardSection,QItemSection,QSeparator,QList,QItem,QIcon,QBadge}, component.options.components || {})
